var _ellipse, _ellipse2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 55,
    viewBox: "0 0 59 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.2607,
    cy: 27.7253,
    rx: 11.7392,
    ry: 22.4558,
    fill: "#87C6FF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1873,
    cy: 27.5722,
    rx: 8.03208,
    ry: 18.9423,
    fill: "#CAD5E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27_28857)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.6129,
    height: 55,
    rx: 27.5,
    fill: "#0A2642"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.2117,
    y: 37.165,
    width: 7.72737,
    height: 20.7431,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.72616,
    cy: 27.5724,
    rx: 4.1705,
    ry: 3.97177,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5232,
    y: 37.165,
    width: 4.41564,
    height: 20.7431,
    fill: "#CAD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64502 27.5727C8.64502 21.1608 13.8429 15.9629 20.2548 15.9629H27.1806V39.1825H20.2548C13.8429 39.1825 8.64502 33.9846 8.64502 27.5727Z",
    fill: "#008DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0625 15.8335C30.5446 15.1245 38.7581 12.5519 43.7559 7.12305V47.8394C40.8219 44.9715 33.3803 39.1361 27.0741 39.129C27.0703 39.129 27.0664 39.129 27.0625 39.129C23.6688 39.129 20.9177 33.9141 20.9177 27.4813C20.9177 21.0484 23.6688 15.8335 27.0625 15.8335C27.0625 15.8335 27.0625 15.8335 27.0625 15.8335V15.8335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.2607,
    cy: 27.7253,
    rx: 11.7392,
    ry: 22.4558,
    fill: "#87C6FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1873,
    cy: 27.5722,
    rx: 8.03207,
    ry: 18.9423,
    fill: "#CAD5E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3585 31.6306C40.236 30.3269 40.1714 28.9727 40.1714 27.5834C40.1714 26.194 40.236 24.8398 40.3585 23.5361C42.5341 23.6329 44.2679 25.4079 44.2679 27.5834C44.2679 29.7588 42.5341 31.5338 40.3585 31.6306Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27_28857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.6129,
    height: 55,
    rx: 27.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/Megaphone.37271b28f29ef99c26f6f1e392536ea2.svg";
export { ForwardRef as ReactComponent };